export default __webpack_public_path__ + "static/media/Breast Right.dd4210a5.jpg";